export default __webpack_public_path__ + "node_modules/jquery-ui-dist/images/ui-icons_777620_256x240.png";